(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    var input = document.querySelector(".cc-contact-form input[type='tel']");

    if (input && window.intlTelInput) {
      window.intlTelInput(input, {
        initialCountry: "fr",
        separateDialCode: true,
        utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@23.0.4/build/js/utils.js"
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-blog-article"]) return;
  try {
    
(function () {
  const TOC_EXCLUDED = new Set([
    'faq',
    'ce qu il faut retenir',
    'vous aimerez aussi lire'
  ]);

  function normalizeTitle(text) {
    return (text || '')
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[''']/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function slugify(text, used) {
    let base = normalizeTitle(text)
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 72) || 'section';
    let slug = base;
    let i = 2;
    while (used.has(slug)) {
      slug = `${base}-${i}`;
      i += 1;
    }
    used.add(slug);
    return slug;
  }

  function isSignificantParagraph(el) {
    if (!el || el.tagName !== 'P') return false;
    const text = (el.textContent || '').replace(/\s+/g, ' ').trim();
    if (text.length < 40) return false;
    if (el.querySelector('img, iframe, table')) return false;
    return true;
  }

  function pruneEmptyBlockquotes(root) {
    root.querySelectorAll('blockquote').forEach((blockquote) => {
      const text = (blockquote.textContent || '').replace(/\s+/g, ' ').trim();
      if (!text) blockquote.remove();
    });
  }

  function decorateContent(root) {
    const isRecap = root.matches('[data-recap-slot]');
    root.querySelectorAll('h2').forEach((el) => el.classList.add('ca-h2'));
    root.querySelectorAll('h3').forEach((el) => el.classList.add('ca-h3'));
    root.querySelectorAll('h4, h5, h6').forEach((el) => el.classList.add('ca-h3'));
    root.querySelectorAll('p').forEach((el) => el.classList.add('ca-p'));
    root.querySelectorAll('ul').forEach((el) => {
      el.classList.add('ca-ul');
      if (isRecap) el.classList.add('custom-article__recap-list');
    });
    root.querySelectorAll('ol').forEach((el) => {
      el.classList.add('ca-ol');
      if (isRecap) el.classList.add('custom-article__recap-list');
    });
    root.querySelectorAll('blockquote').forEach((el) => el.classList.add('ca-blockquote'));
    root.querySelectorAll('a').forEach((el) => el.classList.add('ca-link'));
    root.querySelectorAll('strong, b').forEach((el) => el.classList.add('ca-strong'));
    root.querySelectorAll('em, i').forEach((el) => el.classList.add('ca-em'));
    root.querySelectorAll('img').forEach((el) => el.classList.add('ca-img'));
    root.querySelectorAll('iframe').forEach((el) => el.classList.add('ca-iframe'));
    root.querySelectorAll('figure').forEach((el) => el.classList.add('ca-figure'));
    root.querySelectorAll('figcaption').forEach((el) => el.classList.add('ca-figcaption'));

    root.querySelectorAll('table').forEach((table) => {
      if (table.parentElement && table.parentElement.classList.contains('ca-table-wrap')) return;
      const wrap = document.createElement('div');
      wrap.className = 'ca-table-wrap';
      table.classList.add('ca-table');
      table.parentNode.insertBefore(wrap, table);
      wrap.appendChild(table);
    });

    pruneEmptyBlockquotes(root);
  }

  function collectUntilNextH2(startNode) {
    const nodes = [];
    let node = startNode.nextElementSibling;
    while (node && node.tagName !== 'H2') {
      const next = node.nextElementSibling;
      nodes.push(node);
      node = next;
    }
    return nodes;
  }

  function sectionNodesFrom(h2) {
    const nodes = [h2];
    let node = h2.nextElementSibling;
    while (node && node.tagName !== 'H2') {
      nodes.push(node);
      node = node.nextElementSibling;
    }
    return nodes;
  }

  function placeSlotAt(slot, h2) {
    const parent = h2.parentNode;
    if (parent) parent.insertBefore(slot, h2);
    slot.hidden = false;
  }

  function buildTocEntries(content) {
    const entries = [];
    content.querySelectorAll('h2').forEach((h2) => {
      const norm = normalizeTitle(h2.textContent);
      if (TOC_EXCLUDED.has(norm)) return;
      entries.push({ el: h2, level: 2 });
      let node = h2.nextElementSibling;
      while (node && node.tagName !== 'H2') {
        if (node.tagName === 'H3') entries.push({ el: node, level: 3 });
        node = node.nextElementSibling;
      }
    });
    return entries;
  }

  function appendTocItem(list, entry) {
    const li = document.createElement('li');
    li.className = entry.level === 3
      ? 'custom-article__toc-item custom-article__toc-item--h3'
      : 'custom-article__toc-item custom-article__toc-item--h2';
    const a = document.createElement('a');
    a.href = `#${entry.el.id}`;
    const label = (entry.el.textContent || '').trim();
    if (entry.level === 3) {
      a.innerHTML = `<span class="custom-article__toc-marker" aria-hidden="true">›</span> ${label.replace(/</g, '&lt;')}`;
    } else {
      a.textContent = label;
    }
    li.appendChild(a);
    list.appendChild(li);
    return li;
  }

  function buildFaq(faqH2, faqSlot, content, enableSchema) {
    const schemaItems = [];
    const nodes = sectionNodesFrom(faqH2);
    faqH2.classList.add('ca-h2');
    faqSlot.appendChild(faqH2);
    faqSlot.hidden = false;
    let index = 1;

    while (index < nodes.length) {
      const node = nodes[index];
      if (node.tagName !== 'H3') {
        if (node.isConnected && content.contains(node)) node.remove();
        index += 1;
        continue;
      }

      const question = (node.textContent || '').trim();
      const answerNodes = [];
      index += 1;

      while (index < nodes.length && nodes[index].tagName !== 'H3') {
        answerNodes.push(nodes[index]);
        index += 1;
      }

      const details = document.createElement('details');
      details.className = 'custom-article__faq-item';
      const summary = document.createElement('summary');
      summary.textContent = question;

      const answer = document.createElement('div');
      answer.className = 'custom-article__faq-answer custom-article__prose';
      answerNodes.forEach((n) => answer.appendChild(n));

      details.append(summary, answer);
      faqSlot.appendChild(details);
      node.remove();

      if (enableSchema && question) {
        schemaItems.push({
          '@type': 'Question',
          name: question,
          acceptedAnswer: {
            '@type': 'Answer',
            text: answer.textContent.trim()
          }
        });
      }
    }

    decorateContent(faqSlot);
    return schemaItems;
  }

  function refreshProductsSwiper(block) {
    const swiperEl = block?.querySelector('complementary-product-cards-swiper');
    if (!swiperEl) return;

    const run = (attempts = 0) => {
      if (typeof Swiper === 'undefined') {
        if (attempts < 30) setTimeout(() => run(attempts + 1), 100);
        return;
      }
      if (typeof swiperEl.refresh === 'function') {
        swiperEl.refresh();
      } else if (typeof swiperEl.initSwiper === 'function') {
        swiperEl.initSwiper();
      }
    };

    requestAnimationFrame(() => run());
  }

  function initProductsCarousel(section) {
    const block = section.querySelector('[data-products-block]');
    if (!block || section.dataset.hasProducts !== 'true') return;
    refreshProductsSwiper(block);
  }

  function extractBlock(h2, slot) {
    const nodes = collectUntilNextH2(h2);
    slot.appendChild(h2);
    nodes.forEach((n) => slot.appendChild(n));
    slot.hidden = false;
    decorateContent(slot);
  }

  function initArticle(section) {
    const content = section.querySelector('[data-article-content]');
    if (!content) return;

    decorateContent(content);

    const showSummary = section.dataset.showSummary === 'true';
    const summarySlot = section.querySelector('[data-summary-slot]');
    const summaryLabel = section.dataset.summaryLabel || 'En résumé';

    if (showSummary && summarySlot) {
      const firstP = content.querySelector('p');
      if (isSignificantParagraph(firstP)) {
        const wrap = document.createElement('aside');
        wrap.className = 'custom-article__summary';
        wrap.setAttribute('aria-label', summaryLabel);
        const label = document.createElement('p');
        label.className = 'custom-article__summary-label';
        label.textContent = summaryLabel;
        const body = document.createElement('div');
        body.className = 'custom-article__summary-body';
        body.appendChild(firstP.cloneNode(true));
        wrap.append(label, body);
        summarySlot.replaceWith(wrap);
        firstP.remove();
      } else {
        summarySlot.remove();
      }
    } else if (summarySlot) {
      summarySlot.remove();
    }

    const showToc = section.dataset.showToc === 'true';
    const tocSlot = section.querySelector('[data-toc-slot]');
    const tocList = section.querySelector('[data-toc-list]');
    const usedIds = new Set();

    const h2Elements = [...content.querySelectorAll('h2')];
    h2Elements.forEach((h2) => {
      if (!h2.id) {
        h2.id = slugify(h2.textContent, usedIds);
      } else {
        usedIds.add(h2.id);
      }
      h2.classList.add('ca-h2');
    });

    content.querySelectorAll('h3').forEach((h3) => {
      if (!h3.id) {
        h3.id = slugify(h3.textContent, usedIds);
      } else {
        usedIds.add(h3.id);
      }
      h3.classList.add('ca-h3');
    });

    if (showToc && tocSlot && tocList) {
      const tocMax = parseInt(section.dataset.tocMaxItems || '5', 10);
      let entries = buildTocEntries(content);
      if (entries.length > tocMax) {
        entries = entries.filter((entry) => entry.level === 2);
      }

      if (entries.length) {
        let currentH2Li = null;
        entries.forEach((entry) => {
          if (entry.level === 2) {
            currentH2Li = appendTocItem(tocList, entry);
          } else if (entry.level === 3 && currentH2Li) {
            let subList = currentH2Li.querySelector(':scope > .custom-article__toc-sublist');
            if (!subList) {
              subList = document.createElement('ol');
              subList.className = 'custom-article__toc-sublist';
              currentH2Li.appendChild(subList);
            }
            appendTocItem(subList, entry);
          }
        });
        tocSlot.hidden = false;
      } else {
        tocSlot.remove();
      }
    } else if (tocSlot) {
      tocSlot.remove();
    }

    const recapSlot = section.querySelector('[data-recap-slot]');
    const faqSlot = section.querySelector('[data-faq-slot]');
    let faqSchemaItems = [];
    const enableFaqSchema = section.dataset.enableFaqSchema === 'true';

    [...content.querySelectorAll('h2')].forEach((h2) => {
      const norm = normalizeTitle(h2.textContent);
      if (norm === 'vous aimerez aussi lire') {
        collectUntilNextH2(h2).forEach((n) => n.remove());
        h2.remove();
      }
    });

    [...content.querySelectorAll('h2')].forEach((h2) => {
      if (normalizeTitle(h2.textContent) === 'ce qu il faut retenir' && recapSlot) {
        extractBlock(h2, recapSlot);
      }
    });

    [...content.querySelectorAll('h2')].forEach((h2) => {
      if (normalizeTitle(h2.textContent) === 'faq' && faqSlot) {
        faqSchemaItems = buildFaq(h2, faqSlot, content, enableFaqSchema);
      }
    });

    initProductsCarousel(section);

    if (enableFaqSchema && faqSchemaItems.length) {
      const script = section.querySelector('[data-faq-schema]');
      if (script) {
        script.textContent = JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'FAQPage',
          mainEntity: faqSchemaItems
        });
        script.hidden = false;
      }
    }

    [recapSlot, faqSlot].forEach((slot) => {
      if (slot && slot.hidden && slot.childElementCount === 0) slot.remove();
    });

    decorateContent(content);
  }

  function initArticleSafe(section) {
    if (!section || section.dataset.caReady === 'true') return;
    initArticle(section);
    section.dataset.caReady = 'true';
  }

  function initAllArticles(root) {
    (root || document).querySelectorAll('.js-custom-article').forEach(initArticleSafe);
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (!event.target.classList.contains('cc-custom-blog-article')) return;
    initArticleSafe(event.target.querySelector('.js-custom-article'));
  });

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    initAllArticles();
  } else if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAllArticles());
  } else {
    initAllArticles();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter =
          !isLargeScreen &&
          window.location.hash === '#footer-signup_form' &&
          this.querySelector('#footer-signup_form') !== null;

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if (this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lead-gen-form"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    var input = document.querySelector("#phone");

    if (input && window.intlTelInput) {
      window.intlTelInput(input, {
        initialCountry: "fr",
        separateDialCode: true,
        utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@23.0.4/build/js/utils.js"
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
